/** @format */

import React from "react";

//material ui
import { Box } from "@mui/material";

//components
import Benefits from "../components/CodingChallenge/Benefits";
import CourseModality from "../components/CodingChallenge/CourseModality";
import BeforeStarting from "../components/CodingChallenge/BeforeStarting";
import CodingChallengeText from "../components/CodingChallenge/CodingChallengeText";
import CodingChallengeTitle from "../components/CodingChallenge/CodingChallengeTitle";
import CodingChallengeStages from "../components/CodingChallenge/CodingChallengeStages";

const useStyles = () => ({
	div: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		flexDirection: "column",
	},
	homeBox: {
		display: { xs: "flex" },
		justifyContent: { xs: "center" },
		alignItems: { xs: "center", md: "flex-start" },
		flexDirection: { xs: "column" },
		width: { md: "850px", lg: "1100px", xl: "1300px" },
	},
});

const CodingChallenge = () => {
	const classes = useStyles();

	return (
		<Box sx={classes.div}>
			<CodingChallengeTitle />
			<CodingChallengeText />
			<Benefits />
			<CodingChallengeStages />
			<BeforeStarting />
			<CourseModality />
		</Box>
	);
};

export default CodingChallenge;
